'use client';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

export function useGclid() {
  const [gclid, setGclid] = useState<string | null>(null)
  const searchParams = useSearchParams()

  useEffect(() => {
    // 优先从 URL 参数获取
    const urlGclid = searchParams.get('gclid')
    if (urlGclid) {
      setGclid(urlGclid)
      return
    }

    // 从 cookie 获取
    const getCookie = (name: string) => {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) {
        return parts.pop()?.split(';').shift() || null
      }
      return null
    }

    const cookieGclid = getCookie('gclid')
    setGclid(cookieGclid)
  }, [searchParams])

  return { gclid }
}
